import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatBottomSheet} from '@angular/material';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {HeaderService} from '../../../../services/header.service';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {ReportService} from '../../../../services/report.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {SortConsentBottomSheetComponent} from '../sort-consent-bottom-sheet/sort-consent-bottom-sheet.component';

@Component({
    selector: 'app-child-history-consents',
    templateUrl: './child-history-consents.component.html',
    styleUrls: ['./child-history-consents.component.scss']
})
export class ChildHistoryConsentsComponent implements OnInit, OnDestroy {
    isLoading: boolean;
    consents: any = [];
    displayConsents: any = [];
    listHeight;
    subscription: Subscription;
    user: any;

    constructor(private headerService: HeaderService,
                public router: Router,
                private localStorageService: LocalStorageService,
                private bottomSheet: MatBottomSheet,
                private reportService: ReportService,
                public consentsFormService: ConsentsFormService,
                public toastService: ToastMessagesService) {
        this.isLoading = true;
        this.listHeight = window.innerHeight - 100;
        this.user = JSON.parse(this.localStorageService.get('user'));

    }

    async ngOnInit(): Promise<void> {
        try {
            this.initSubscriptions();
            await this.initComponent();
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    initSubscriptions() {
        this.subscription = this.headerService.observerShowBottomSheet().subscribe(state => {
            if (state) {
                this.openBottomSheet();
            }
        });
    }

    async initComponent() {
        this.headerService.setHeaderTitle(`Ιστορικό δηλώσεων`);
        await this.initChildConsentsHistory();
    }

    async initChildConsentsHistory() {
        const originalForms = await this.reportService.getCustomFormsReportForChildrenHistory();
        for (const form of originalForms) {
            form.formTitle = form.title;
            form.displayName = `${form.child_first_name} ${form.child_last_name}`;
            form.modified_by = form.modified_by ? `${form.modified_by_first_name} ${form.modified_by_last_name}` : '-';
            form.consentDate = form.modified_at;
        }
        console.log(originalForms);
        this.consents = originalForms.slice();
        this.displayConsents = this.consents.slice();

        this.sortConsents('consentDate', 'date', 'desc');
    }


    openBottomSheet() {
        const bottomSheet = this.bottomSheet.open(SortConsentBottomSheetComponent, {
            data: {
                items: [
                    {
                        key: 'consentDate',
                        label: 'Ημερομηνία συμπλήρωσης',
                        type: 'date',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'consentDate',
                        label: 'Ημερομηνία συμπλήρωσης',
                        type: 'date',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                    {
                        key: 'formTitle',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}

                    },
                    {
                        key: 'formTitle',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                    {
                        key: 'displayName',
                        label: 'Ονοματεπώνυμο χρήστη',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'displayName',
                        label: 'Ονοματεπώνυμο χρήστη',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                ]
            }
        });

        bottomSheet.afterDismissed().subscribe(response => {
            if (response) {
                this.sortConsents(response.key, response.type, response.order.key);
                this.headerService.setShowBottomSheet(false);
            }
        });
    }

    sortConsents(sortBy: string = null, type: string = null, direction: string = null) {
        try {
            this.isLoading = true;
            this.displayConsents = [];
            if (direction) {
                if (direction === 'asc') {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) > this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) > this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : (b[sortBy] > a[sortBy]) ? -1 : 0);
                    }
                } else {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) < this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) < this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : (b[sortBy] < a[sortBy]) ? -1 : 0);
                    }
                }
            }

            this.displayConsents = this.consents.slice();
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    private stringToDate(dateString: string): Date {
        try {
            const tempString = dateString.split('-');
            const tempTime = tempString[2].split(' ');
            const year = tempTime[0];
            const month = tempString[1];
            const day = tempString[0];
            const time = tempTime[1];

            const formattedDateString = `${year}-${month}-${day} ${time}`;
            return new Date(formattedDateString);
        } catch (e) {
            return null;
        }
    }

    async showCustomForm(form) {
        const inputConfig = {
            edit: false,
            childId: form.childId ? form.childId : form.child_id,
            mode: true,
            parentId: this.user.id,
            unique_id: form.unique_id ? form.unique_id : form.form_unique_id,
            id: form.reportId ? form.reportId : form.id,
            update: true
        };

        if (!this.isNavigationToFormDisabled(form)) {
            await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
        } else {
            this.toastService.toastMessages(`Δεν έχετε δικαίωμα να τροποποιήσετε τη δήλωση`);
        }
    }

    isNavigationToFormDisabled(consent: any) {
        return +consent.status === -1;
    }

}
